import styled from 'styled-components'
import LoginMethodFormBlock from 'src/components/LoginMethodFormBlock'

import MainLayout from '../../layouts/MainLayout'
import BoxedContainer from '../../components/BoxedContainer'
import RegisterForm from '../../forms/RegisterForm'
import BannerTextActions from '../../components/BannerBlockLeftRight'
import Icon from '../../components/Icon'
import LoginFormBlock from '../../components/LoginFormBlock'

export const Layout = styled(MainLayout)``

export const PageTitle = styled.h1`
  ${({ theme }) => theme.textStyles.firaSans6Xl};
  color: ${({ theme }) => theme.colors.bluePrimary};

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    ${({ theme }) => theme.textStyles.firaSans4Xl};
    margin-top: 0;
  }
`
export const Wrapper = styled(BoxedContainer)`
  margin: 5rem auto;
  position: relative;
`
export const RegisterFormStyled = styled(RegisterForm)``
export const LoginFormStyled = styled(LoginFormBlock)``
export const LoginMethodFormStyled = styled(LoginMethodFormBlock)``

export const Banner = styled(BannerTextActions)`
  margin-bottom: 3.5rem;
`

export const Crosses = styled(Icon)`
  position: absolute;
  right: 100%;
  top: 1rem;

  ${({ theme }) => theme.breakpoints.down('desktop')} {
    display: none;
  }
`
